import './Payment.css'
import {showToast} from "../utils/methods";
import {Component} from "react";

class payment extends Component {
    pressDownload(){
        showToast('Coming soon!')
    }
    render() {
        return (
            <div className="antivirus section-bg-white">
                <div className='payment-title'>Payment</div>
                <div className='payment-container'>
                    <div className="payment-card">
                        <div className='payment-1'>VIP Membership</div>
                        <div className={'duration-text'}>Monthly Pass</div>
                        <div className={'membership-price'}>$20 USD</div>
                        <button className='payment-button' onClick={this.pressDownload.bind(this)}>Purchase</button>
                    </div>
                    <div className="payment-card">
                        <div className='payment-1'>VIP Membership</div>
                        <div className={'duration-text'}>Season Pass</div>
                        <div className={'membership-price'}>$55 USD</div>
                        <button className='payment-button' onClick={this.pressDownload.bind(this)}>Purchase</button>
                    </div>
                    <div className="payment-card">
                        <div className='payment-1'>VIP Membership</div>
                        <div className={'duration-text'}>Semi-Annual Pass</div>
                        <div className={'membership-price'}>$95 USD</div>
                        <button className='payment-button' onClick={this.pressDownload.bind(this)}>Purchase</button>
                    </div>
                    <div className="payment-card" id='purchase'>
                        <div className='payment-1'>VIP Membership</div>
                        <div className={'duration-text'}>Annual Pass</div>
                        <div className={'membership-price'}>$165 USD</div>
                        <button className='payment-button' onClick={this.pressDownload.bind(this)}>Purchase</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default payment